import React, {forwardRef} from 'react';
import AutoComplete from './AutoComplete';

const MultiAutoComplete = (props, ref) => {
  return <AutoComplete {...props} ref={ref} multiple />;
};

export default forwardRef(MultiAutoComplete);
